import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {InventoryEntityModel} from "../../inventory/inventory-entity.model";
import {InventoryGroupEntityModel} from "../inventory-group-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "inventory-group-edit-page",
    templateUrl: "./inventory-group-edit-page.component.html",
    providers: [provideEntityModel(InventoryGroupEntityModel)]
})
export class InventoryGroupEditPageComponent extends AbstractEditPage {
    constructor(public model: InventoryGroupEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
